<section>
  <div
    class="w-full py-3 flex align-items-center justify-content-between border-bottom-1 border-bottom-solid mb-3"
    [style]="{ 'border-color': 'var(--primary-gray)' }"
  >
    <h2 class="text-xl font-semibold" data-clarity-unmask="true">Dodaj kursantów do grupy</h2>
    <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" [disabled]="saving" (onClick)="closeDialog()" data-clarity-unmask="true"></p-button>
  </div>
</section>

<section>
  <div class="form-rows">
    <div class="form-row">
      <span class="form-row__label">Grupa</span>
      <div class="form-row__control">
        <span class="font-medium">{{ group.name }}</span>
        <span class="text-gray-500 ml-2">kategoria {{ group.examName }}</span>
      </div>
    </div>
    <div class="form-row">
      <label for="lectureGroupNewStudents" class="form-row__label">Kursanci</label>
      <div class="form-row__control">
        <p-multiSelect
          inputId="lectureGroupNewStudents"
          styleClass="custom-multiselect w-full"
          [options]="studentOptions"
          [(ngModel)]="selectedStudentGuids"
          optionLabel="label"
          optionValue="value"
          placeholder="wybierz"
          [filter]="true"
          filterBy="label,name"
          filterPlaceHolder="Szukaj kursanta"
          emptyFilterMessage="Nie znaleziono kursanta"
          emptyMessage="Wszyscy aktywni kursanci są już w tej grupie"
          selectedItemsLabel="Wybrano: {0}"
          [maxSelectedLabels]="3"
          [showToggleAll]="true"
          appendTo="body"
          [loading]="loadingOptions"
        >
          <ng-template let-student pTemplate="item">
            <div class="flex flex-column">
              <span>{{ student.label }}</span>
              <small class="text-gray-500" *ngIf="student.name">{{ student.name }}</small>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>
  </div>

  <div class="flex pt-4 justify-content-end gap-3">
    <p-button label="Anuluj" [outlined]="true" [disabled]="saving" (onClick)="closeDialog()" data-clarity-unmask="true"></p-button>
    <p-button
      label="Dodaj do grupy"
      icon="pi pi-user-plus"
      [loading]="saving"
      [disabled]="loadingOptions || selectedStudentGuids.length === 0"
      (onClick)="save()"
      data-clarity-unmask="true"
    ></p-button>
  </div>
</section>
